<template>
    <div class="gameListBox">
        <div class="scrollContent">
            <div class="gameItemBox" v-for="(item, index) in gameList" :key="index" @click="gotoGame(item)">
                <div class="imgBox">
                    <img :src="`/manager/fileserver/file/download?id=${item.topicPic}`" />
                </div>
                <div class="testBox">
                    <div class="testName">{{item.name}}</div>
                    <div class="testType" >
                        <span v-if="item.type == 'wheel'">大转盘</span>
                        <span v-if="item.type == 'gold'">点屏成金</span>
                    </div>
                    <div class="testDate">活动期限：{{item.endDate}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "gameList",
        mounted() {
            document.title = "活动列表"

            this.$http.get('/sangto-wrm/activity/game/page', {
                params:{
                    status:2
                }
            }).then(({data})=>{
                let arr = data.data.rows
                let time = new Date().getTime()
                arr.forEach(item => {

                    let newTime = new Date(item.endDate.replace(/-/g, '/')).getTime()
                    if(newTime > time){
                        this.gameList.push(item)
                    }

                })
            })
        },
        data(){
            return {
                gameList:[]
            }
        },
        methods:{
            gotoGame(item){
                if(item.type == "wheel") { //转盘
                    this.$router.push({path:'/gameWheel',query:{id:item.id}})
                }else if(item.type == 'gold'){ //点金
                    this.$router.push({path:'/gameGold', query:{itemData:JSON.stringify(item)}})
                }
            }
        }
    }
</script>

<style scoped lang="scss">
.gameListBox{
    width: 100%;
    height: 100%;
    background-color: #f8f8f8;
    overflow: auto;
    overflow-x: hidden;
    display: flex;
    justify-content: center;
    .scrollContent{
        width: 90%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 12px;
    }
    .gameItemBox{
        margin-top: 10px;
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        background-color: #fff;
        box-shadow: 1px 1px 4px 0 rgba(0,0,0,0.1);
        border-radius: 6px;
    }
    .imgBox{
        margin-left: 12px;
        width: 84px;
        height: 72px;
        img{
            width: 100%;
            height: 100%;
        }
    }

    .testBox{
        font-size: 14px;
        width: 200px;
        height: 75px;
        margin-left: 14px;
        display: flex;
        flex-direction: column;
        div{
            margin-top: 4px;
        }

    }
    .testType{
        color: #666;
    }
    .testDate{
        font-size: 12px;
    }
    .testDate{
        color: #666;
    }
}
</style>
